import React, { useEffect, useMemo } from 'react';

import { selectLocationPrerequisites, selectSelectedLocation, setLocation } from 'store/exams-search/examsSearchSlice';
import { selectPreparationCentre } from 'store/country/countrySlice';
import { useAppDispatch, useAppSelector } from 'store';
import { useLazyGetLocationsQuery } from 'store/exams-search/examsSearchAPI';

import { ApiErrorPage, BcSelect } from '@britishcouncil/react-solas-ors3';
import { Alert, LoadingContainer } from '@britishcouncil/react-solas';

export const LocationSelect = () => {
  const dispatch = useAppDispatch();
  const locationPrerequisites = useAppSelector(selectLocationPrerequisites);
  const location = useAppSelector(selectSelectedLocation);
  const pcInfo = useAppSelector(selectPreparationCentre);

  const [triggerLocationQuery, { data, error, isFetching }] = useLazyGetLocationsQuery();

  const locations = useMemo(() => (pcInfo ? data?.filter((x) => x.id === pcInfo.districtId) : data), [data, pcInfo]);

  useEffect(() => {
    if (locationPrerequisites.complete) {
      triggerLocationQuery({
        ...locationPrerequisites,
        sessionId: locationPrerequisites.session!.sessionId
      });
    }
  }, [triggerLocationQuery, locationPrerequisites]);

  if (!locationPrerequisites.complete) return null;

  if (error) return <ApiErrorPage />;

  return (
    <LoadingContainer loading={isFetching}>
      {locations && locations.length === 0 && <Alert type="warning">There are currently no locations</Alert>}
      {locations && locations.length > 0 && (
        <>
          <label htmlFor="location-select">Location</label>
          <BcSelect
            id="location-select"
            isLoading={isFetching}
            options={locations}
            value={location}
            placeholder="Select location"
            onChange={(selected: unknown) => dispatch(setLocation(selected as string))}
          />
        </>
      )}
    </LoadingContainer>
  );
};
